// Dictionnaire Français
const fr = {
    common: {
        loading: 'Chargement...',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        back: 'Retour',
        close: 'Fermer',
        search: 'Rechercher',
        filter: 'Filtrer',
        actions: 'Actions',
        confirm: 'Confirmer',
        download: 'Télécharger',
        details: 'Détails',
        none: 'Aucun',
        all: 'Tous',
        today: "Aujourd'hui",
        this_week: 'Cette semaine',
        this_month: 'Ce mois',
        urgent: 'URGENT',
        late: 'EN RETARD',
        status: 'Statut',
        date: 'Date',
        translate: 'Traduire en chinois',
        translating: 'Traduction...',
        show_original: 'Voir original',
        translated: 'Traduit',
        error: 'Erreur',
        success: 'Succès'
    },
    nav: {
        dashboard: 'Tableau de bord',
        jobs: 'Travaux',
        clients: 'Praticiens',
        accounting: 'Comptabilité',
        products: 'Produits',
        profile: 'Mon Profil',
        settings: 'Paramètres',
        logout: 'Déconnexion',
        lab_manager: 'Lab Manager',
        partner: 'Partenaire de production',
        switch_language: 'Langue'
    },
    status: {
        all: 'Tous les statuts',
        recu: 'Reçu',
        en_cours: 'En cours',
        production: 'En production',
        en_attente: 'En attente',
        termine: 'Terminé',
        expedie: 'Expédié',
        livre: 'Livré',
        facture: 'Facturé',
        annule: 'Annulé',
        a_refaire: 'À refaire',
        pending_reply: 'En attente de réponse'
    },
    labwork: {
        search_placeholder: 'Rechercher par patient, praticien, n°...',
        all_dates: 'Toutes les dates',
        filter_status_label: 'Statut :',
        filter_date_label: 'Période :',
        col_number: 'N° Dossier',
        col_date_received: 'Date réception',
        col_patient: 'Patient',
        col_practitioner: 'Praticien',
        col_work: 'Travail à réaliser',
        col_teeth: 'Dents',
        col_shade: 'Teinte',
        col_status: 'Statut',
        col_delivery: 'Livraison prévue',
        col_actions: 'Actions',
        no_cases_found: 'Aucun dossier trouvé pour ces critères',
        unread_msg: 'message(s) non lu(s)',
        waiting_reply_badge: 'Réponse attendue',
        days_left: 'j restants',
        today_deadline: "Aujourd'hui !",
        overdue: 'En retard de',
        open_dossier: 'Ouvrir le dossier',
        chat: 'Discussion',
        has_3d: 'Fichiers 3D disponibles'
    },
    dossier: {
        back_to_list: 'Retour à la liste',
        title: 'FICHE DE TRAVAIL',
        case_no: 'N° DOSSIER',
        subcontractor_view: 'Vue de production',
        practitioner_box: 'PRATICIEN',
        patient_box: 'PATIENT',
        received_date: 'Date de réception :',
        due_date: 'Date de livraison prévue :',
        status_label: 'Statut actuel :',
        table_tooth: 'Dent',
        table_work: 'Travail à réaliser',
        table_qty: 'Quantité',
        table_shade: 'Teinte',
        work_instruction: 'Consigne de travail :',
        work_notes_title: 'Consignes & Notes de Travail',
        mandatory_instruction: 'Note de fabrication à respecter',
        no_special_notes: 'Aucune consigne particulière spécifiée pour ce travail.',
        general_notes: 'Remarques générales du bon de commande :',
        attached_files_title: 'Documents & Fichiers 3D (STL)',
        view_3d_files: 'Voir les fichiers 3D',
        open_chat: 'Ouvrir la discussion',
        chat_subtitle: 'Échanges directs avec le laboratoire',
        change_status_prompt: 'Changer le statut du cas :',
        save_status: 'Mettre à jour le statut',
        translate_all_notes: 'Traduire les consignes en chinois'
    },
    chat: {
        title: 'Discussion sur le dossier',
        empty_title: 'Aucun échange pour le moment',
        empty_producer: 'Posez une question au laboratoire concernant ce cas',
        empty_lab: 'Commencez la discussion avec votre partenaire',
        sender_lab: '🏭 Laboratoire ENOVADENT',
        sender_partner: '👤 Partenaire Usine',
        placeholder: 'Écrivez un message...',
        send: 'Envoyer',
        translate_msg: 'Traduire en chinois',
        translate_to_fr: 'Traduire en français',
        translated_by_ai: 'Traduction automatique',
        view_original: 'Voir original',
        delete_confirm: 'Supprimer ce message ?',
        just_now: "À l'instant",
        typing: 'Écrit...'
    }
};

export default fr;
